module.exports = __webpack_public_path__ + "img/undraw_credit_card_df1m.7ae8c361.svg";